import { useGetBillToLocationUrl } from '@user/store/authorization'
import { useGetExternalAppName } from '@user/store/authorization/hooks/useGetExternalAppName'

type Props = {
  billToId: string
}

export function useData(props: Props) {
  const { billToId } = props

  const externalAppName = useGetExternalAppName()
  const externalLinkLabel = `Manage in ${externalAppName}`

  const locationUrl = useGetBillToLocationUrl(billToId)

  return { externalLinkLabel, locationUrl }
}
